import Vue from "vue";
import Vuex from "vuex";
import baseStore from "../../../stores/baseStore";
import alertsStore from "../../../stores/modules/alerts.store";
import authStore from "../../../stores/modules/auth.store";
import downloadsStore from "../../../stores/modules/downloads.store";
import errorsStore from "../../../stores/modules/errors.store";
import activeCall from "./modules/activeCall.store";
import calendarEvents from "./modules/calendarEvents.store";
import campaigns from "./modules/campaigns.store";
import cart from "./modules/cart.store";
import clients from "./modules/clients.store";
import clientsPendingId from "./modules/clientsPendingId.store";
import clientsUnpaid from "./modules/clientsUnpaid.store";
import clientsUnregistered from "./modules/clientsUnregistered.store";
import commissions from "./modules/commissions.store";
import comparisons from "./modules/comparisons.store";
import dashboard from "./modules/dashboard.store";
import factFinds from "./modules/factFinds.store";
import groups from "./modules/groups.store";
import idChecks from "./modules/idChecks.store";
import instructions from "./modules/instructions.store";
import introductions from "./modules/introductions.store";
import invitations from "./modules/invitations.store";
import invoices from "./modules/invoices.store";
import jobs from "./modules/jobs.store";
import leads from "./modules/leads.store";
import logs from "./modules/logs.store";
import metaKeysStore from "./modules/metaKeys.store";
import metaKeysReferrerStore from "./modules/metaKeysReferrer.store";
import missedLeads from "./modules/missedLeads.store";
import offers from "./modules/offers.store";
import panels from "./modules/panels.store";
import products from "./modules/products.store";
import quotes from "./modules/quotes.store";
import searchPackBundles from "./modules/searchPackBundles.store";
import searchPacks from "./modules/searchPacks.store";
import serviceProviders from "./modules/serviceProviders.store";
import serviceProvidersTeams from "./modules/serviceProvidersTeams.store";
import serviceProvidersUsers from "./modules/serviceProvidersUsers.store";
import services from "./modules/services.store";
import teams from "./modules/teams.store";
import unlinkedPostcodes from "./modules/unlinkedPostcodes.store";
import users from "./modules/users.store";

Vue.use(Vuex);

const portalStore = new Vuex.Store(Object.assign(
	{},
	baseStore,
	{
		modules: {
			metaKeysStore,
			metaKeysReferrerStore,
			activeCall,
			alertsStore,
			downloadsStore,
			authStore,
			calendarEvents,
			campaigns,
			cart,
			clients,
			clientsPendingId,
			clientsUnpaid,
			clientsUnregistered,
			comparisons,
			dashboard,
			errorsStore,
			factFinds,
			groups,
			idChecks,
			instructions,
			introductions,
			leads,
			logs,
			missedLeads,
			commissions,
			invoices,
			jobs,
			invitations,
			searchPacks,
			searchPackBundles,
			serviceProviders,
			serviceProvidersTeams,
			serviceProvidersUsers,
			services,
			teams,
			users,
			offers,
			panels,
			products,
			quotes,
			unlinkedPostcodes,
		},
	},
));

export default portalStore;
